import React, { useState } from "react";
import { Button, Dropdown, Menu, Input, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchasePoModel } from "../purchasePoModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchasePoDetailsModel } from "../view/details/purchasePoDetailsModel"
import { DownOutlined } from "@ant-design/icons";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
import { PrintTable } from "./PrintTable";


export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, detailsExport, exportPurchasePo, invalidate, setPrint, AcceptanceLedgerExport } = usePurchasePoModel();
    const { serChangeSaleDrawer, setDetailEditForm, setDetailDataSource } = usePurchasePoDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [printVisible, setPrintVisible] = useState<boolean>(false);

    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        if (selectedRow.status == "purchase.change") {
            globalPrompt("message", { text: "该单据已作废，无法进行编辑", type: "warning" });
            return;
        }
        // if (selectedRow.status == "purchase-status.bill") {
        //     globalPrompt("message", { text: "该单据已结算，无法进行编辑", type: "warning" });
        //     return;
        // }
        let supplierEditKey = "11-2-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.purchaseCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "采购单跳转详情",
                type: "warning",
                text: "您还有采购单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.purchaseCode as string, mode: "edit" });
                    // updateEditFormVal(null);
                    setDetailEditForm({})
                    setDetailDataSource([])
                }
            })
        }
    }
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.purchaseCode as string, mode: "look", },
            true
        );
    }
    const checkPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行打印，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrintVisible(true);
    }
    const cancellation = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let cancelReason: string = ""
        globalPrompt("modal", {
            title: "采购单作废",
            type: "error",
            text: <><span>请输入作废原因</span>
                <Input onChange={(e) => { cancelReason = e.target.value }} /></>,
            okText: "确定",
            onOk: () => {
                invalidate(cancelReason)
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onTrunSale = () => {
        serChangeSaleDrawer(true)
    }
    const onPrint = (val: any) => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrint({ visible: true, type: val })
    }
    const desc: IDescription[] = [
        {
            label: "采购数量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "采购金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        },
        {
            label: "已付金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.paidAmount : rowsDescTotal.paidAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const exportMenu = () => {
        return (
            <Menu>
                <Menu.Item key="0">
                    <span onClick={() => exportPurchasePo()}>列表导出</span>
                </Menu.Item>
                <Menu.Item key="1">
                    <span onClick={() => detailsExport()}>详情导出</span>
                </Menu.Item>
            </Menu>
        )
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_P_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("11-2-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_EX}>
            <Dropdown overlay={exportMenu}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                // onClick={() => exportPurchasePo().then()}
                >导出<DownOutlined /></Button>
            </Dropdown>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_CANCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={cancellation}
            >作废</Button>
        </YhAuth>
        {/* <YhAuth resCode={ResourceAuthEnum.P_P_REPL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("11-2-1", {
                    id: "", mode: "add", parentInfo: {
                        Supplement: "Supplement"
                    }
                })}
            >补单</Button>
        </YhAuth> */}
        <YhAuth resCode={ResourceAuthEnum.P_P_PRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint("1")}
            >打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_NOPRICEPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint("2")}
            >单据打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_CHECKPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => checkPrint()}
            >验收单打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_P_ACCEPTANCELEDGEREXPORT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => AcceptanceLedgerExport()}
            >验收台账导出</Button>
        </YhAuth>
    </>;

    return (
        <>
            {/* <YhBox title={"采购单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PrintTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
        </>
    )
}